/**
 * ScheduleConfirmationPreview container logic selectors
 *
 * @author Rafael Guedes <rguedes@ubiwhere.com>
 *
 */

import { RootState } from 'store/rootSlices';

export const getSchedulesSlice = (state: RootState) => state.Schedules;
